import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Home from '@mui/icons-material/Home'; 
import Apartment from '@mui/icons-material/Apartment'; 
import Landscape from '@mui/icons-material/Landscape';
import Storefront from '@mui/icons-material/Storefront'; 
import { useNavigate, useOutletContext } from 'react-router-dom';
import PropertyFooterLayout from '../../../components/properties/PropertyFooterLayout';
import { AccountBalance, BedroomParent, Bungalow, Business, CorporateFare, EmojiTransportation, Fence, Gite, HolidayVillage, House, LocationCity, MapsHomeWork, NightShelter, Store, Villa } from '@mui/icons-material';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import LocalConvenienceStoreIcon from '@mui/icons-material/LocalConvenienceStore';

type PublishOutletContext = {
  handleNavigateToType: () => void;
  propertyCategory: string; 
  setPropertyCategory: (propertyCategory: string) => void;
};

const PublishPropertyStructurePage: React.FC = () => {
  const { handleNavigateToType, propertyCategory, setPropertyCategory } = useOutletContext<PublishOutletContext>();
  const navigate = useNavigate();

  const handleCardClick = (option: string) => {
    setPropertyCategory(option); 
  };

  const handleBack = () => {
    navigate(-1); 
  };

  const handleContinue = () => {
    if (propertyCategory) {
      handleNavigateToType(); 
    }
  };

  const progress = 20;
  const step = 1; 

  const options = [
    'Apartamento',
    'Casa',
    'Lote',
    'Condominio',
    'Edificio',
    'Torre',
    'Finca',
    'Local',
    'Terreno',
    'Casa independiente',
    'Penthouse',
    'Townhouse',
    'Apartamento loft',
    'Apartamento estudio',
    'Casa de lujo',
    'Moderna',
    'Rústica',
    'Propiedad Comercial',
    'Oficentro',
    'Mall',
    'Mansión'
  ];

  const getIcon = (option: string) => {
    switch (option) {
      case 'Casa':
        return <Home sx={{ fontSize: 30 }} />;
      case 'Apartamento':
        return <Apartment sx={{ fontSize: 30 }} />;
      case 'Habitaciones':
        return <BedroomParent sx={{ fontSize: 30 }} />;
      case 'Lote':
        return <Landscape sx={{ fontSize: 30 }} />;
      case 'Condominio':
        return <HolidayVillage sx={{ fontSize: 30 }} />;
      case 'Edificio':
        return <Business sx={{ fontSize: 30 }} />;
      case 'Torre':
        return <LocationCity sx={{ fontSize: 30 }} />;
      case 'Finca':
        return <Gite sx={{ fontSize: 30 }} />;
      case 'Local':
        return <Store sx={{ fontSize: 30 }} />;
      case 'Terreno':
        return <Fence sx={{ fontSize: 30 }} />;
      case 'Casa independiente':
        return <NightShelter sx={{ fontSize: 30 }} />;
      case 'Penthouse':
        return <CorporateFare sx={{ fontSize: 30 }} />;
      case 'Townhouse':
        return <Apartment sx={{ fontSize: 30 }} />;
      case 'Apartamento loft':
        return <MapsHomeWork sx={{ fontSize: 30 }} />;
      case 'Apartamento estudio':
        return <EmojiTransportation sx={{ fontSize: 30 }} />;
      case 'Casa de lujo':
        return <House sx={{ fontSize: 30 }} />;
      case 'Moderna':
        return <AccountBalance sx={{ fontSize: 30 }} />;
      case 'Rústica':
        return <Bungalow sx={{ fontSize: 30 }} />;
      case 'Propiedad Comercial':
        return <Storefront sx={{ fontSize: 30 }} />;
      case 'Oficentro':
          return <LocalConvenienceStoreIcon sx={{ fontSize: 30 }} />;
      case 'Mall':
          return <StoreMallDirectoryIcon sx={{ fontSize: 30 }} />;
      case 'Mansión':
          return <Villa sx={{ fontSize: 30 }} />;
      default:
        return null;
    }
  };
  

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pb:6}}>
        {/* Page Title */}
        <Typography variant="h4" gutterBottom sx={{ fontWeight: '500', textAlign: 'center', mb: 4 }}>
          Selecciona la categoría de la propiedad
        </Typography>

        {/* Grid of selection items with icons and names */}
        <Box sx={{ width: '50%' }}>
          <Grid container spacing={3} sx={{ mb: 4 }}>
            {options.map((option) => (
              <Grid size={{xs:12, sm:6, md:4}} key={option}>
                <Card 
                  onClick={() => handleCardClick(option)}
                  sx={{
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    boxShadow: propertyCategory === option ? 8 : 2,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '120px',
                    margin: 'auto',
                    cursor: 'pointer',
                    backgroundColor: propertyCategory === option ? '#b2dfdb' : 'white',
                    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)',
                      transform: 'translateY(-4px)',
                      backgroundColor: propertyCategory === option ? '#b2dfdb' : '#f5f5f5',
                    }
                  }}
                >
                  <CardContent 
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',              
                      p: 1
                    }}
                  >
                    <Box
                      sx={{
                        animation: propertyCategory === option ? 'bounce 0.6s' : 'none',
                        '@keyframes bounce': {
                          '0%': { transform: 'scale(1)' },
                          '50%': { transform: 'scale(1.2)' },
                          '100%': { transform: 'scale(1)' },
                        },
                      }}
                    >
                      {getIcon(option)}
                    </Box>
                    <Typography variant="inherit" sx={{ mt: 1, fontWeight: '500', fontSize: '1.2rem',textAlign: 'center', }}>
                      {option}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <Box sx={{ mt: '40px' }}>
      <PropertyFooterLayout
        progress={progress}
        step={step}
        onBack={handleBack}
        onContinue={handleContinue}
        isContinueDisabled={!propertyCategory}
      />
      </Box>
    </>
  );
};

export default PublishPropertyStructurePage;
